import Http from '@/assets/http'

//维护组提供接口

export const sendRequest = (api, params) =>
  new Http().require(
    {
      api: api,
      param: params,
    },
    false,
    false
  )

//4组提供接口
export const sendBaseRequest = (api, params) =>
  new Http().require(
    {
      api: api,
      param: params,
    },
    true
  )

// export const sendRequestVideo = (api,params) => new Http().require({api: api,param:params},false,true);

export const sendRequestVideo = (api, params) =>
  new Http().upLoad({
    api: api,
    param: params,
  })

// upLoad

export const getOpenid = async (code, url, callbackUrl, callBack) => {
  if (localStorage.getItem('token')) {
    return
  }
  let { content, status } = await sendRequest('user/login_wx', {
    code: code,
  })
  if (status == 2318) {
    localStorage.setItem(
      'pages',
      JSON.stringify({ path: '/personalCenter', query: {} })
    )
    window.location.href = window.location.href.split('?')[0] + url
    return
  }
  if (status == 2368 || status == 2367) {
    var appid = 'wxcef271c70c3c8428' // appid
    var url = callbackUrl // 回调链接地址，需转码为URI格式，必须去除#后的参数
    var scope = 'snsapi_userinfo' // snsapi_base静默授权，snsapi_userinfo弹出授权页面
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`
    return
  }
  if (status == 200) {
    localStorage.setItem('token', content.token)
    localStorage.setItem('infor', JSON.stringify(content))
    callBack()
  }
}
